import * as EventListener from "../helpers/event-listener";
import csrfToken from "../helpers/csrf-token";
import Bowser from "bowser";

const changeLocality = () => {
    EventListener.click("change-product-locale-button", (button) => {
        document.querySelector(".custom-product-step-2-wrapper").innerHTML = "";

        oc.ajax("Settings::onAjax", {
            loading: "#loader-line",
            data: {
                _token: csrfToken,
                step: 1,
            },
            update: {
                "catalog/product-page/custom-product/steps": ".steps-wrapper",
                "catalog/product-page/custom-product/next-step-button":
                    ".next-step-button-wrapper",
                "catalog/product-page/custom-product/last-step":
                    ".last-step-wrapper",
                "catalog/product-page/custom-product/total":
                    ".custom-product-total-wrapper",
            },
        });
    });
};

const goToStep = () => {
    EventListener.click("change-custom-product-step", (button) => {
        const step = button.getAttribute("data-step");

        if (step) {
            oc.ajax("Settings::onAjax", {
                loading: "#loader-line",
                data: {
                    _token: csrfToken,
                    step: step,
                },
                update: {
                    "catalog/product-page/custom-product/steps":
                        ".steps-wrapper",
                },
                complete: () => {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });

                    document
                        .querySelectorAll(".custom-product-step")
                        .forEach((stepElement) => {
                            const step = stepElement.getAttribute("data-step");

                            const stepSectionElement = document.querySelector(
                                `.custom-product-step-${step}`,
                            );

                            if (stepSectionElement) {
                                stepSectionElement.classList.add("hidden");
                            }
                        });

                    const stepSectionElement = document.querySelector(
                        `.custom-product-step-${step}`,
                    );
                    if (stepSectionElement) {
                        stepSectionElement.classList.remove("hidden");
                    }

                    button.disabled = false;
                },
            });
        }
    });
};

const increaseCustomProductPart = () => {
    EventListener.click("increase-custom-product-part", (button) => {
        increaseOrDecreaseCustomProductPart(button, 1);
    });
};

const decreaseCustomProductPart = () => {
    EventListener.click("decrease-custom-product-part", (button) => {
        increaseOrDecreaseCustomProductPart(button, -1);
    });
};

const changeGift = () => {
    EventListener.change("change-custom-product-gift", () => {
        document
            .querySelectorAll(".change-custom-product-gift")
            .forEach((element) => (element.disabled = true));

        const complete = () => {
            document
                .querySelectorAll(".change-custom-product-gift")
                .forEach((element) => (element.disabled = false));
        };

        updatePriceSection(complete);
    });
};

const increaseOrDecreaseCustomProductPart = (button, i) => {
    document
        .querySelectorAll(
            ".decrease-custom-product-part, .increase-custom-product-part",
        )
        .forEach((element) => (element.disabled = true));

    const offerId = button.getAttribute("data-offer-id");

    const input = document.getElementById(`quantity-offer-${offerId}`);

    const max = input.getAttribute("max");

    let value = Number(input.value);
    value = Math.max(0, value + i);
    value = Math.min(value, Number(max));

    input.value = value;

    const complete = () => {
        document
            .querySelectorAll(
                ".decrease-custom-product-part, .increase-custom-product-part",
            )
            .forEach((element) => (element.disabled = false));
    };

    updatePriceSection(complete);
};

const getFormData = () => {
    const form = document.getElementById("addCartPositionToCartForm");
    const formData = new FormData(form);

    const getAnalytics = () => {
        const browser = Bowser.getParser(window.navigator.userAgent);

        return {
            os: browser.getOSName(),
            device: browser.getPlatformType(),
        };
    };

    const getCustomProductParts = (formData) => {
        const customProductParts = [];

        for (const [key, value] of formData.entries()) {
            const match = key.match(/^quantities\[(\d+)\]$/);
            if (match) {
                const quantity = Math.max(0, Number(value));

                if (quantity > 0) {
                    customProductParts.push({
                        offer_id: Number(match[1]),
                        quantity: quantity,
                    });
                }
            }
        }

        return customProductParts;
    };

    const getGifts = () => {
        const checkboxes = form.querySelectorAll(
            ".change-custom-product-gift:checked",
        );

        const giftIds = [];

        checkboxes.forEach((checkbox) => {
            const value = Number(checkbox.value);

            giftIds.push(value);
        });

        return giftIds;
    };

    return {
        _token: csrfToken,
        offer_id: formData.get("item_id"),
        product_type: formData.get("product_type"),
        delivery_date: formData.get("delivery_date"),
        delivery_time: formData.get("delivery_time"),
        shape: formData.get("shape"),
        partner_id: formData.get("partner_id"),
        locality_id: formData.get("locality_id"),
        gift_ids: getGifts(),
        is_express_delivery: formData.get("is_express_delivery"),
        analytics: getAnalytics(),
        custom_product_parts: getCustomProductParts(formData),
    };
};

const updatePriceSection = (complete) => {
    oc.ajax("Settings::onAjax", {
        loading: "#loader-line",
        data: getFormData(),
        update: {
            "catalog/product-page/custom-product/last-step":
                ".last-step-wrapper",
            "catalog/product-page/custom-product/total":
                ".custom-product-total-wrapper",
        },
        complete: () => {
            complete();
        },
    });
};

decreaseCustomProductPart();
increaseCustomProductPart();
changeGift();
changeLocality();
goToStep();
